import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import HowItWorks from "./pages/HowItWorks";
import Mission from "./pages/Mission";
import Partners from "./pages/Partners";
import Pricing from "./pages/Pricing";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import LegalNotices from "./pages/LegalNotices";

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/comment-ca-marche" element={<HowItWorks />} />
              <Route path="/mission-impact" element={<Mission />} />
              <Route path="/partenaires" element={<Partners />} />
              <Route path="/tarifs" element={<Pricing />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
              <Route path="/conditions-utilisation" element={<TermsOfService />} />
              <Route path="/mentions-legales" element={<LegalNotices />} />
              {/* Redirection pour index.html */}
              <Route path="/index.html" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;